import { OrderOrganizerAction } from "./order-organizer-action";
import { OrderOrganizer } from "src/app/shared/models/order-organizer.model";

export class OrderOrganizerRemoveAction extends OrderOrganizerAction{
  constructor(organizer: OrderOrganizer, action: (OrderOrganizer) => void) {
    super("Remove", true, organizer, action);
  }
}
